export default __webpack_public_path__ + "static/media/r200-4.b50a9039.png";